// src/components/common/LoadingScreen.jsx
import React, { useEffect, useRef } from 'react';

export default function LoadingScreen({ text = 'Loading...' }) {
  const barsRef = useRef([]);
  const startTimeRef = useRef(null);

  useEffect(() => {
    // Get or create the global animation start time
    if (!window.__loadingAnimationStartTime) {
      window.__loadingAnimationStartTime = Date.now();
    }
    startTimeRef.current = window.__loadingAnimationStartTime;

    // Calculate elapsed time since animation started
    const elapsed = Date.now() - startTimeRef.current;
    const animationDuration = 2100; // 2.1s in milliseconds
    const offset = (elapsed % animationDuration) / animationDuration;

    // Apply the animation delay offset to each bar
    barsRef.current.forEach((bar, index) => {
      if (bar) {
        const baseDelay = index * 0.3; // 0s, 0.3s, 0.6s
        const adjustedDelay = baseDelay - offset * 2.1;
        bar.style.animationDelay = `${adjustedDelay}s`;
      }
    });

    // Cleanup on unmount (but keep the global start time)
    return () => {
      // Don't reset the start time - let it persist
    };
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default'
      }}
    >
      <style>
        {`
          .loading-container {
            width: 80px;
            height: 80px;
            position: relative;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            gap: 8px;
          }
          .loading-bar {
            width: 4px;
            background: #1f4b8e;
            border-radius: 4px;
            height: 40px;
            transform: skew(-15deg);
            clip-path: inset(100% 0 0 0);
            will-change: clip-path;
            animation: clipBar 2.1s infinite linear;
          }
          .loading-text {
            margin-top: 24px;
            font-size: 16px;
            color: #64748b;
            font-weight: 500;
            letter-spacing: 0.025em;
          }
          @keyframes clipBar {
            0% {
              clip-path: inset(100% 0 0 0);
            }
            14% {
              clip-path: inset(0% 0 0 0);
            }
            57% {
              clip-path: inset(0% 0 0 0);
            }
            71% {
              clip-path: inset(0 0 100% 0);
            }
            100% {
              clip-path: inset(0 0 100% 0);
            }
          }
        `}
      </style>
      <div className="loading-container">
        <div 
          className="loading-bar" 
          ref={el => barsRef.current[0] = el}
        ></div>
        <div 
          className="loading-bar" 
          ref={el => barsRef.current[1] = el}
        ></div>
        <div 
          className="loading-bar" 
          ref={el => barsRef.current[2] = el}
        ></div>
      </div>
      <div className="loading-text">
        {text}
      </div>
    </div>
  );
}